import * as api from '@sloyd/api';
import { actions, selectors } from '@sloyd/store-base';
import { put, select } from 'saga-ts';
import { invokeEvent } from 'shared-base';
import { Json } from '../../types';

export function* fixModelNames(models: Json[]) {
  try {
    const generators = yield* select(selectors.raw.$rawGenerators);

    for (const model of Object.values(models)) {
      const { name, generatorId } = model;

      if (!name) {
        const generator = generators[generatorId];
        if (generator) {
          const { name: generatorName } = generator;
          model.name = generatorName;
        }
      }
    }
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

type Callback = (models: IModel[]) => IModel[];

export function* changeProjectModels(id: string, callback: Callback) {
  try {
    const project = yield* select(selectors.single.$project, id);

    if (!project) {
      throw new Error('No project ' + id);
    }

    const { models = [] } = project;
    const nextModels = callback(models);

    yield put(actions.projects.patch(id, { models: nextModels }));
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* addToAnotherProject(model: Json) {
  try {
    const project = yield* select(selectors.single.$project, model.projectId);
    if (!project) return;
    const { models } = project;
    if (!models) return;
    const nextModels = { ...models, [model.id]: model };
    yield put(actions.projects.patch(model.projectId, { models: nextModels }));
    yield api.projects.addModel(model.projectId, model);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}
